import type { Case, SampleAsset } from "@telespot/domain";

import { type Command } from "@telespot/core";

/**
 * Registration token for {@link CopyCases}
 *
 * @group Workspaces
 * @category Tokens
 */
export const COPY_CASES = "copy:cases";

/**
 * Details for {@link CopyCases}
 *
 * @group Workspaces
 * @category Payloads
 */
export interface CopyCaseDetails {
  caseId: string;
  workspaceId: string;
}

/**
 * Copies a case to a given workspace, if the case and the workspace are compatible.
 * Compatibility is defined by {@link Case.isCompatibleWith}.
 *
 * It also makes a copy of all samples, including its related assets ({@link SampleAsset}).
 *
 * //TODO: rename to CopyCase (singular)
 *
 * @group Workspaces
 * @category Commands
 */
export class CopyCases implements Command<typeof COPY_CASES, CopyCaseDetails> {
  public readonly name = COPY_CASES;

  constructor(public readonly details: CopyCaseDetails) { }
}
